(function () {
  'use strict';

  // --- Drawer controls -----------------------------------------------------
  const drawers = document.querySelectorAll('.drawer');
  const drawerMap = new Map();
  drawers.forEach((d) => drawerMap.set(d.dataset.drawer, d));

  function openDrawer(name) {
    const d = drawerMap.get(name);
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawers() {
    drawers.forEach((d) => d.setAttribute('aria-hidden', 'true'));
    document.documentElement.style.overflow = '';
  }

  document.querySelectorAll('[data-drawer-open]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer(btn.dataset.drawerOpen);
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeDrawers();
    });
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });

  // --- Quantity inputs (generic) ------------------------------------------
  document.querySelectorAll('.quantity-input').forEach((wrap) => {
    const input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('button[data-qty]').forEach((b) => {
      b.addEventListener('click', () => {
        let v = parseInt(input.value, 10) || 0;
        v = b.dataset.qty === 'increase' ? v + 1 : Math.max(parseInt(input.min || '0', 10), v - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // --- Product media gallery (slides + arrows + thumbs) -------------------
  document.querySelectorAll('[data-media-gallery]').forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('.product-media-slide'));
    if (slides.length === 0) return;
    const thumbsWrap = gallery.parentElement.querySelector('.product-media-thumbs');
    const thumbs = thumbsWrap ? Array.from(thumbsWrap.querySelectorAll('.product-media-thumb')) : [];

    let activeIndex = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));

    const setActive = (next) => {
      if (slides.length === 0) return;
      const idx = ((next % slides.length) + slides.length) % slides.length;
      if (idx === activeIndex) return;
      slides[activeIndex].classList.remove('is-active');
      slides[idx].classList.add('is-active');
      if (thumbs[activeIndex]) thumbs[activeIndex].classList.remove('is-active');
      if (thumbs[idx]) thumbs[idx].classList.add('is-active');
      activeIndex = idx;
    };

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', (e) => { e.preventDefault(); setActive(i); });
    });

    gallery.querySelectorAll('[data-media-nav]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        setActive(activeIndex + (btn.dataset.mediaNav === 'next' ? 1 : -1));
      });
    });

    // Keyboard nav when gallery is focused/hovered
    gallery.tabIndex = 0;
    gallery.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); setActive(activeIndex + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); setActive(activeIndex - 1); }
    });
  });

  // --- Stats count-up ------------------------------------------------------
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
  const COUNT_DURATION = 1800; // ms — fast start, slow finish via easeOutCubic

  const prepareCountTarget = (el) => {
    if (el.dataset.countReady) return;
    const original = el.textContent;
    // Wrap any digit runs with span[data-count]; keep separators (spaces, %, etc.)
    const wrapped = original.replace(/\d+/g, (match) => `<span data-count="${match}">0</span>`);
    if (wrapped !== original) {
      el.innerHTML = wrapped;
      el.dataset.countReady = '1';
    } else {
      el.dataset.countReady = 'noop';
    }
  };

  const animateCounters = (root) => {
    const spans = root.querySelectorAll('[data-count]');
    spans.forEach((span) => {
      const target = parseInt(span.dataset.count, 10);
      if (!isFinite(target)) return;
      if (span.dataset.countAnimated) return;
      span.dataset.countAnimated = '1';
      const start = performance.now();
      const step = (now) => {
        const elapsed = now - start;
        const t = Math.min(elapsed / COUNT_DURATION, 1);
        const eased = easeOutCubic(t);
        const value = Math.round(target * eased);
        span.textContent = value;
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
  };

  const statValues = document.querySelectorAll('.stat-card__value');
  if (statValues.length && 'IntersectionObserver' in window) {
    statValues.forEach(prepareCountTarget);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCounters(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    statValues.forEach((el) => io.observe(el));
  } else {
    // Fallback: set final values immediately
    statValues.forEach((el) => {
      el.querySelectorAll('[data-count]').forEach((s) => { s.textContent = s.dataset.count; });
    });
  }

  // --- Product form variant select sync -----------------------------------
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    const variantSelect = productForm.querySelector('select[name="id"]');
    const radios = productForm.querySelectorAll('input[type="radio"][name^="options"]');
    function syncVariant() {
      if (!variantSelect) return;
      const chosen = {};
      productForm.querySelectorAll('input[type="radio"][name^="options"]:checked').forEach((r) => {
        const name = r.name.match(/options\[(.+)\]/);
        if (name) chosen[name[1]] = r.value;
      });
      for (const option of variantSelect.options) {
        const t = option.textContent.trim().split(' - ')[0];
        const values = t.split(' / ');
        const optionNames = Object.keys(chosen);
        const match = optionNames.every((n, i) => values[i] === chosen[n]);
        if (match) { option.selected = true; break; }
      }
    }
    radios.forEach((r) => r.addEventListener('change', syncVariant));
  }

  // --- Cart drawer interactions (AJAX) ------------------------------------
  async function fetchCartState() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function updateCartItem(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.json();
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count; });
  }

  async function refreshCartDrawer() {
    const res = await fetch(window.location.pathname, { headers: { 'X-Requested-With': 'fetch' } });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer]');
    const current = document.querySelector('[data-cart-drawer]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    const cart = await fetchCartState();
    setCartCount(cart.item_count);
    bindCartDrawerEvents();
  }

  function bindCartDrawerEvents() {
    document.querySelectorAll('[data-cart-qty]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const input = document.querySelector(`[data-cart-qty-input][data-key="${key}"]`);
        let qty = parseInt(input.value, 10) || 0;
        qty = btn.dataset.cartQty === 'increase' ? qty + 1 : Math.max(0, qty - 1);
        input.value = qty;
        await updateCartItem(key, qty);
        refreshCartDrawer();
      });
    });
    document.querySelectorAll('[data-cart-qty-input]').forEach((input) => {
      input.addEventListener('change', async () => {
        await updateCartItem(input.dataset.key, parseInt(input.value, 10) || 0);
        refreshCartDrawer();
      });
    });
    document.querySelectorAll('[data-cart-remove]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        await updateCartItem(btn.dataset.key, 0);
        refreshCartDrawer();
      });
    });
  }
  bindCartDrawerEvents();

  // --- Add-to-cart AJAX ----------------------------------------------------
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      if (document.body.dataset.ajaxCartDisabled) return;
      e.preventDefault();
      const formData = new FormData(productForm);
      const submit = productForm.querySelector('button[type="submit"]');
      if (submit) submit.disabled = true;
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (!res.ok) throw new Error('cart add failed');
        await refreshCartDrawer();
        openDrawer('cart');
      } catch (err) {
        productForm.submit();
      } finally {
        if (submit) submit.disabled = false;
      }
    });
  }

  // --- Smooth accordion (native <details>) --------------------------------
  function initAccordion(root) {
    (root || document).querySelectorAll('details.accordion-item').forEach((details) => {
      if (details.dataset.accInit) return;
      details.dataset.accInit = '1';
      const summary = details.querySelector('summary');
      const body = details.querySelector('.accordion-item__body');
      if (!summary || !body) return;

      const setClosedInline = () => {
        body.style.height = '0px';
      };
      const setOpenInline = () => {
        body.style.height = body.scrollHeight + 'px';
      };

      if (!details.open) setClosedInline();

      summary.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = details.open;

        if (isOpen) {
          // Closing: set current height, then transition to 0
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              body.style.height = '0px';
            });
          });
          const onEnd = (ev) => {
            if (ev.propertyName !== 'height') return;
            body.removeEventListener('transitionend', onEnd);
            details.open = false;
          };
          body.addEventListener('transitionend', onEnd);
        } else {
          // Opening: open, then animate from 0 to scrollHeight
          details.open = true;
          body.style.height = '0px';
          requestAnimationFrame(() => {
            body.style.height = body.scrollHeight + 'px';
          });
          const onEnd = (ev) => {
            if (ev.propertyName !== 'height') return;
            body.removeEventListener('transitionend', onEnd);
            body.style.height = 'auto';
          };
          body.addEventListener('transitionend', onEnd);
        }
      });

      // Keep height fluid on window resize (for open items)
      window.addEventListener('resize', () => {
        if (details.open && body.style.height && body.style.height !== 'auto') {
          body.style.height = 'auto';
        }
      });
    });
  }
  initAccordion();

  // Re-init accordions added by Shopify theme editor
  document.addEventListener('shopify:section:load', (e) => initAccordion(e.target));

  // --- Testimonial carousel (auto-rotating reviews, horizontal slide) -----
  // Driven by the Web Animations API so the slide runs even if a
  // prefers-reduced-motion CSS rule is ever (re)introduced — this store
  // deliberately keeps the motion. Degrades to a static review 1 without JS.
  function initTestimonialCarousels(root) {
    (root || document).querySelectorAll('[data-testimonial-carousel]').forEach((carousel) => {
      if (carousel.dataset.tcInit) return;
      const track = carousel.querySelector('[data-testimonial-track]');
      if (!track) return;
      const slides = Array.from(track.querySelectorAll('.product-testimonial--slide'));
      if (slides.length < 2) return; // single review: static, no carousel
      carousel.dataset.tcInit = '1';

      const dots = Array.from(carousel.querySelectorAll('[data-dot]'));
      const interval = (parseFloat(carousel.dataset.interval) || 6) * 1000;
      const count = slides.length;

      // Clone review 1 and append it, so advancing past the last review slides
      // into an identical first review, then resets position invisibly.
      const clone = slides[0].cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);

      let pos = 0;        // 0..count (count = the clone)
      let timer = null;
      let animating = false;

      const setDots = (realIndex) => {
        dots.forEach((d, i) => d.classList.toggle('is-active', i === realIndex));
      };

      const goTo = (next, animate) => {
        const realIndex = ((next % count) + count) % count;
        const to = 'translateX(' + (-next * 100) + '%)';
        const settle = () => { if (pos === count) { pos = 0; track.style.transform = 'translateX(0)'; } };
        if (animate === false || typeof track.animate !== 'function') {
          track.style.transform = to;
          pos = next; setDots(realIndex); settle();
          return;
        }
        if (animating) return;
        animating = true;
        const from = 'translateX(' + (-pos * 100) + '%)';
        pos = next; setDots(realIndex);
        const anim = track.animate(
          [{ transform: from }, { transform: to }],
          { duration: 600, easing: 'cubic-bezier(.4, 0, .2, 1)', fill: 'forwards' }
        );
        anim.onfinish = () => {
          track.style.transform = to;
          try { anim.cancel(); } catch (e) {}
          settle();
          animating = false;
        };
      };

      const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
      const start = () => { stop(); timer = setInterval(() => goTo(pos + 1, true), interval); };

      track.style.transform = 'translateX(0)';
      setDots(0);
      dots.forEach((dot, i) => dot.addEventListener('click', () => { goTo(i, true); start(); }));
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);

      start();
    });
  }
  initTestimonialCarousels();
  document.addEventListener('shopify:section:load', (e) => initTestimonialCarousels(e.target));
})();
